import { GET_INVESTMENTS, LOADING_GET_INVESTMENTS } from "../types";

const INITIAL_STATE = {
  investments: [],
  investment: {},
  loadingGetInvestments: false,
};

const investmentsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_INVESTMENTS:
      return { ...state, investments: action.payload };
    case LOADING_GET_INVESTMENTS:
      return { ...state, loadingGetInvestments: action.payload };

    default:
      return state;
  }
};

export default investmentsReducer;
